const getShort = (text = '', onStart = 10, atTheEnd = 7) => {
    if(text.length < 20) return text;
    return text.slice(0,10) + '...' + text.slice(-7);
}
export default getShort